import React from "react";
import { Typography } from "antd";
import { MonthsDisplay } from "src/entity/common/unit.constant";
import { ActionDisplays } from "src/entity/history/history-entity";

const { Text } = Typography;

interface HistoryActionProps {
  action: string;
  detail: any;
}
const HistoryAction: React.FC<HistoryActionProps> = (props) => {
  const { action, detail } = props;
  const actionDisplays = ActionDisplays;

  const renderActionDetail = (action: string, detail: any) => {
    let actionLabel = actionDisplays.find((item) => item.key === action)?.label || action;

    if (action === "reject" || action === "approved") {
      // const actionLabel = actionDisplays.find((item) => item.key === action)?.label || action;
      const parameter = detail?.parameter?.body;
      const selectedMonth = parameter?.selectedMonths || [];
      const year = parameter?.year || "";
      const month = parameter?.month || "";
      const selectedMonthsDisplay =
        parameter?.selectedMonths
          ?.map((month: any) => {
            return MonthsDisplay.find((display) => display.dataIndex.toLowerCase() === month.toLowerCase())?.title || month;
          })
          .join(",") || [];
      const displayMonth = MonthsDisplay.find((display) => display.dataIndex.toLowerCase() === month.toLowerCase())?.title || month;
      const comment = parameter?.comment ? `Comment: "${parameter?.comment}"` : "";

      // const selectedMonths = parameter?.selectedMonths?.join(", ") || [];
      // Example:
      // Rejected for January and February 2023
      // Comment: "Need more data"

      const detailDisplay = selectedMonth?.length > 0 ? `${selectedMonthsDisplay} ${year}` : month ? `${displayMonth} ${year}` : "";

      if (selectedMonth?.length > 0 || month) {
        return (
          <Text>
            {actionLabel} - For {detailDisplay}
            <br />
            {comment}
          </Text>
        );
      } else if (year) {
        return (
          <Text>
            {actionLabel} - For {year}
            <br />
            {comment}
          </Text>
        );
      } else {
        return <Text>{actionLabel}</Text>;
      }
    } else if (action === "submit_report") {
      // Submit Report for January 2023
      const parameter = detail?.parameter?.body;
      const year = parameter?.year || "";
      const months = parameter?.months || [];
      const monthDisplay =
        months
          ?.map((month: any) => {
            return MonthsDisplay.find((display) => display.dataIndex.toLowerCase() === month.toLowerCase())?.title || month;
          })
          .join(",") || [];

      if (months && year) {
        return (
          <Text>
            {actionLabel} - For {monthDisplay} {year}
          </Text>
        );
      }
    } else {
      return <Text>{actionLabel}</Text>;
    }
  };
  return <div>{renderActionDetail(action, detail)}</div>;
};

export default HistoryAction;
